import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "app" }

import SfHeader from '@/layout/SfHeader.vue'
import SfContent from '@/layout/SfContent.vue'
import SfFooter from '@/layout/SfFooter.vue'
import ScrollToTop from '@/components/ScrollToTop.vue'
import { useAppStore } from '@/stores/app'
// element-plus换肤
import { useElementPlusTheme } from '@/utils/theme'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const app = useAppStore()
useElementPlusTheme('#E31D33')


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SfHeader),
    _createVNode(SfContent),
    _createVNode(SfFooter),
    _createVNode(ScrollToTop)
  ])), [
    [
      _directive_loading,
      _unref(app).fullscreenLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}
}

})